"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFooter = void 0;
const react_1 = __importDefault(require("react"));
function ModalFooter({ children }) {
    return (react_1.default.createElement("div", { className: "py-4 px-6 bg-surface-subdued flex justify-between items-center rounded-b-lg" }, children));
}
exports.ModalFooter = ModalFooter;
//# sourceMappingURL=ModalFooter.js.map